import {RecurringStatus} from "./enums/RecurringStatus";
import {utcToZonedTime} from "date-fns-tz";
import {differenceInCalendarDays, endOfMonth, startOfMonth} from "date-fns";

export class EventHelper {
  static isRecurringEvent = (recurringStatus: string | RecurringStatus) =>
    recurringStatus === RecurringStatus.Series ||
    recurringStatus === RecurringStatus.DetachedSeries;

  static getIconColorClass = (
    isCancelledOrPostponed: boolean,
    isPastEvent: boolean,
    isRecurringEvent: boolean,
    isBookableEvent: boolean,
    isPreReleaseInPastAndEventInUnreleasedPeriod: boolean
  ): string => {
    let colorClass = "";

    // no color class when event is cancponed
    if (isCancelledOrPostponed) return colorClass;

    colorClass =
      (isRecurringEvent ? "recurring" : "") +
      (isPastEvent ? "-past" : "") +
      (isBookableEvent ? "-bookable" : "-non-bookable") +
      (isPreReleaseInPastAndEventInUnreleasedPeriod ? "-unreleased" : "");

    return !!colorClass ? colorClass + "-color" : colorClass;
  };

  /**
   * Filters out all occurrences that don't fall in the weeks provided.
   */
  static filterOccurrences(
    occurrences: Date[],
    weeks: number[],
    timezone: string
  ): Date[] {
    const filteredOccurrences: Date[] = [];
    const lastWeek = -1;

    for (const occurrence of occurrences) {
      // Calculate the week of the month for the date
      const localDate = utcToZonedTime(occurrence, timezone);
      const weekNum = EventHelper.getWeekOfMonth(occurrence, timezone);

      // Check if we need to include occurrences in the last week
      if (weeks.includes(lastWeek)) {
        const endOfMonthDate = endOfMonth(localDate);
        const lastWeekStartDate = endOfMonthDate.getDate() - 7;

        if (localDate.getDate() > lastWeekStartDate) {
          if (!weeks.includes(weekNum)) {
            filteredOccurrences.push(occurrence);
          }
          continue;
        }
      }

      if (weeks.includes(weekNum)) {
        filteredOccurrences.push(occurrence);
      }
    }

    return filteredOccurrences;
  }

  static getWeekOfMonth = (date: Date, timezone: string): number => {
    const localDate = utcToZonedTime(date, timezone);
    const start = startOfMonth(localDate);
    const dayDifference = differenceInCalendarDays(localDate, start);
    return Math.floor(dayDifference / 7) + 1;
  };
}
